import api from "../components/interceptors.js"; // adjust path if needed

export const getChargerProfile = async ({ customer_id, station_id }) => {
  const res = await api.post("/api/getChargerProfile", {
    customer_id,
    station_id,
  });

  return res.data;
};
